module.exports = __webpack_public_path__ + "static/img/gsjj.0c1cc45b.png";